<template>
    <div class="bg-primary-150 px-4 py-4 text-gray-750 md:leading-none lg:px-0">
        <div
            v-if="
                highlightWebinar &&
                (highlightWebinar.status === 'preparing' ||
                    highlightWebinar.status === 'started')
            "
            class="flex w-full flex-col items-center justify-center gap-4 md:flex-row"
        >
            <div
                class="flex flex-wrap items-center gap-2 text-[16px] leading-relaxed text-gray-700 md:flex-row"
            >
                <div class="">
                    <span
                        class="relative flex h-3 w-3 items-center justify-center"
                    >
                        <span
                            class="absolute inline-flex h-full w-full animate-ping rounded-full bg-red-200 opacity-75"
                        ></span>
                        <span
                            class="relative inline-flex h-2 w-2 rounded-full bg-red-500"
                        ></span>
                    </span>
                </div>
                <div class="font-semibold">Live Now:</div>
                <text-clamp
                    :text="highlightWebinar.title"
                    :max-lines="1"
                    autoResize
                />
            </div>
            <!--            <Link-->
            <!--                :href="-->
            <!--                    route('student.live-events.show', {-->
            <!--                        live_event: highlightWebinar.id,-->
            <!--                    })-->
            <!--                "-->
            <!--                class="rounded-full border border-primary-400 px-3 py-2 text-[16px] text-primary-400 hover:cursor-pointer hover:bg-primary-400/10"-->
            <!--            >-->
            <!--                Watch Webinar-->
            <!--            </Link>-->
        </div>
        <div
            v-else-if="highlightWebinar"
            class="flex w-full flex-col items-center justify-center gap-4 md:flex-row md:justify-between"
        >
            <div
                class="flex items-center gap-2 border-gray-400 pr-2 text-[16px] md:border-r"
            >
                <span
                    class="rounded border border-primary-400 p-2 font-medium text-primary-400"
                    >{{ highlightWebinarUntil.days }}</span
                >
                days
                <span
                    class="rounded border border-primary-400 p-2 font-medium text-primary-400"
                    >{{ highlightWebinarUntil.hours }}</span
                >
                hrs
            </div>
            <div
                class="flex flex-col items-center gap-2 text-[16px] leading-none text-gray-700 md:flex-row md:leading-relaxed"
            >
                <div class="font-semibold">Upcoming Webinar:</div>
                <text-clamp
                    :text="highlightWebinar.title"
                    :max-lines="1"
                    autoResize
                />
                <div>
                    <span class="mr-2 hidden md:inline-block">·</span>
                    <span>{{
                        dayjs(highlightWebinar.starts_at).format(
                            $page.props.date_formats.full_nice
                        )
                    }}</span>
                </div>
            </div>
            <AddToCalendarWidget
                :event="highlightWebinar"
                button-css="rounded-full border border-primary-400 px-3 py-2 text-[16px] text-primary-400 hover:cursor-pointer hover:bg-primary-400/10"
            />
        </div>
    </div>
</template>
<script>
import AddToCalendarWidget from "@/Components/AddToCalendarWidget.vue";
import dayjs from "dayjs";

export default {
    name: "LiveEventsNextLiveBanner",
    components: { AddToCalendarWidget },
    props: {
        highlightWebinar: {
            type: Object,
            default: {},
        },
    },
    computed: {
        highlightWebinarUntil() {
            let totalHours, daysUntil, hoursUntil;
            let startsAt = dayjs(this.highlightWebinar.starts_at);
            let now = dayjs();

            totalHours = startsAt.diff(now, "hours");

            daysUntil = Math.floor(totalHours / 24);
            hoursUntil = totalHours % 24;

            return { days: daysUntil, hours: hoursUntil };
        },
    },
};
</script>
